import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { useAuth } from "../contexts/AuthContext";
import CircularProgressLoader from "@Components/CircularProgressLoader";
const LoginForm = () => {
    const [formError, setFormError] = useState(null);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { loading, login } = useAuth();
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (email === "" || password === "") {
            setFormError('Please provide both an email and a password');
            return;
        }
        try {
            await login(email, password);
        }
        catch (error) {
            console.error('Error logging in:', error);
        }
    };
    if (loading) {
        return (_jsx(CircularProgressLoader, {}));
    }
    return (_jsxs(Box, { component: "form", onSubmit: handleSubmit, sx: { mt: 1, maxWidth: '400px' }, children: [formError && (_jsx(Typography, { variant: "body1", color: "error", align: "center", children: formError })), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, id: "email", label: "Username", name: "email", autoComplete: "email", autoFocus: true, value: email, onChange: (e) => setEmail(e.target.value) }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, name: "password", label: "Password", type: "password", id: "password", autoComplete: "current-password", value: password, onChange: (e) => setPassword(e.target.value) }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, disabled: !email || !password, children: "Sign In" })] }));
};
export default LoginForm;
